<template>
    <div>
    <v-navigation-drawer
            v-model="drawer"
            :mini-variant.sync="mini"
            permanent
            fixed
    >
        <v-list-item>
            <v-list-item-icon>
                <img src="../../assets/logo.png" width="30">
            </v-list-item-icon>

            <v-list-item-title>Umbrella</v-list-item-title>

            <v-btn
                    icon
                    @click.stop="mini = !mini"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
            <v-list-item
                    v-for="item in items"
                    :key="item.title"
                    :to="item.to"
                    link
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
<!--    <b-sidebar width="250px" id="sidebar-1" no-close-on-route-change v-bind:visible="isSidebarShown" no-close-on-esc no-enforce-focus aria-labelledby="sidebar-no-header-title" no-header-->
<!--               shadow @hidden="onSideBarHidden" @change="onSideBarChange" @shown="onSideBarShown"-->
<!--    >-->
<!--        <div class="px-3 py-2">-->
<!--            <h1 class="text-center header-dark" id="sidebar-no-header-title">-->
<!--                <img src="../../assets/favicon.png" alt="logo" width="35px" class="mr-3"/>umbrella</h1>-->
<!--            <nav class="mb-3">-->
<!--                <b-nav vertical>-->
<!--                    <b-nav-item to="/" exact exact-active-class="active"><i class="fas fa-tachometer-alt"></i> Dashboard</b-nav-item>-->
<!--                    <b-nav-item to="/users" exact exact-active-class="active"><i class="fas fa-users"></i> Users</b-nav-item>-->
<!--                    <b-nav-item to="/roles" exact exact-active-class="active"><i class="fas fa-user-tag"></i> Roles</b-nav-item>-->
<!--                    <b-nav-item to="/applications" exact exact-active-class="active"><i class="fab fa-app-store"></i> Applications</b-nav-item>-->
<!--                </b-nav>-->
<!--            </nav>-->
<!--        </div>-->
<!--    </b-sidebar>-->
    </div>
</template>

<script>

export default {
  name: 'Sidebar',
  data() {
    return {
      drawer: true,
      items: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard',
          to: '/',
        },
        {
          title: 'Users',
          icon: 'fas fa-user',
          to: '/users',
        },
        {
          title: 'Roles',
          icon: 'fas fa-user-tag',
          to: '/roles',
        },
        {
          title: 'Applications',
          icon: 'fab fa-app-store',
          to: '/applications',
        },
      ],
      mini: true,
    };
  },
  methods: {
    onSideBarShown() {
      this.isSidebarShown = true;
    },
    onSideBarChange() {
      this.toggleBodyClass(this.isSidebarShown ? 'remove' : 'add', 'with-sidebar-opened');
    },
    onSideBarHidden() {
      this.isSidebarShown = false;
    },
    toggleBodyClass(addRemoveClass, className) {
      const element = document.body;

      if (addRemoveClass === 'add') {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    },
  },
  created() {
    this.toggleBodyClass(this.isSidebarShown ? 'add' : 'remove', 'with-sidebar-opened');
  },
};
</script>

<style scoped lang="sass">
    .nav-item
        border-bottom: 1px solid #5c6489
        padding-top: 10px
        padding-bottom: 10px
        &:first-child
            border-top: 1px solid #5c6489
        .nav-link
            font-size: 16px
            &.active
                color: #36b8e1
            i
                font-size: 20px
                margin-right: 10px
</style>
